import {forwardRef, memo} from 'react';
import {BoxOptionSelector} from '../box-option-selector';
import {cn} from '../lib/cn';

export interface SwitchBlocksOption {
  id: string;
  title: string;
  description: string;
  value: string;
  switch?: {
    value: string;
  };
}

export interface SwitchBlocksProps {
  options: SwitchBlocksOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
}

const SwitchBlocksInternal = forwardRef<HTMLDivElement, SwitchBlocksProps>(
  ({options, value, onChange, disabled, className}, ref) => (
    <div
      ref={ref}
      className={cn('flex flex-wrap items-center justify-start gap-4', className)}
    >
      {options.map(option => (
        <BoxOptionSelector
          key={option.id}
          id={option.id}
          title={option.title}
          description={option.description}
          value={option.value}
          switch={option.switch}
          onChange={onChange}
          disabled={disabled}
          selectedValue={value}
        />
      ))}
    </div>
  ),
);

SwitchBlocksInternal.displayName = 'SwitchBlocks';

export const SwitchBlocks = memo(SwitchBlocksInternal);
